import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const ComingSoon = () => {
  return (
    <Container fluid className="min-vh-100 d-flex align-items-center justify-content-center" style={{backgroundColor:"#FFF4FA"}}>
      <Row className="text-center w-100">
        <Col>
          <h1 className="display-4 fw-bold text-primary">Coming Soon</h1>
          <p className="lead text-muted">We’re working hard to bring you something amazing. Stay tuned!</p>
        </Col>
      </Row>
    </Container>
  );
};

export default ComingSoon;
